import { FileType } from '../models/file-item.model';

export function isVideoFiletype(filetype: FileType) {
    return filetype === FileType.Video || filetype === FileType.Stream || filetype === FileType.StreamsVideo;
}